const indexItems = [
  { title: '国产热播剧', desc: '最新上线的国产大剧全集', count: '386部', icon: 'ri-tv-line', color: 'text-primary-600 bg-primary-100' },
  { title: '韩剧精选', desc: '高分韩剧实时更新', count: '215部', icon: 'ri-heart-line', color: 'text-accent-600 bg-accent-100' },
  { title: '美剧专区', desc: '经典与新番美剧合集', count: '178部', icon: 'ri-global-line', color: 'text-secondary-600 bg-secondary-100' },
  { title: '日剧治愈', desc: '温暖治愈系日剧推荐', count: '143部', icon: 'ri-sun-line', color: 'text-accent-600 bg-accent-100' },
  { title: '古装大戏', desc: '服化道精良的古装巨制', count: '256部', icon: 'ri-building-2-line', color: 'text-primary-600 bg-primary-100' },
  { title: '悬疑探案', desc: '烧脑悬疑高分好剧', count: '198部', icon: 'ri-search-eye-line', color: 'text-secondary-600 bg-secondary-100' },
  { title: '动画番剧', desc: '国内外热门动漫合集', count: '312部', icon: 'ri-movie-line', color: 'text-accent-600 bg-accent-100' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <p className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-semibold mb-4">
            <i className="ri-list-check-3 text-sm w-4 h-4 flex items-center justify-center"></i>
            专题索引
          </p>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">全部分类浏览</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">按类型和地区快速定位您感兴趣的剧集，轻松找到想看的精彩内容。</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {indexItems.map((item) => (
            <div key={item.title} className="group bg-background-50 rounded-xl p-5 border border-background-200/60 hover:border-primary-200 transition-colors cursor-pointer text-center">
              <div className={`w-12 h-12 mx-auto flex items-center justify-center rounded-xl ${item.color} mb-3`}>
                <i className={`${item.icon} text-lg w-5 h-5 flex items-center justify-center`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">{item.title}</h3>
              <p className="text-xs text-foreground-500 mb-2">{item.desc}</p>
              <span className="text-[11px] text-foreground-400">{item.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}